import { gql } from "apollo-boost";

const GET_PRODUCT_LIST = gql`
  query getProductList($input: GetListInputV1) {
    getProductList(input: $input) {
      status
      error
      data {
        ... on SellerProductListData {
          count
          productList {
            _id
            approved
            status
            title
            sku
            updatedAt
            vendor
            vendorId
            images {
              imageUrl
            }
            liveConnect {
              platform
            }
            productId
            vendorShopifyProductId
            createdAt
            variants {
              barcode
              comparePrice
              customRule
              customLabel
              customCharge
              sku
              vendorDiscount {
                price
                type
              }
            }
            isService
            serviceId
            isDraft
          }
        }
      }
    }
  }
`;
const GET_PRODUCT_LIST_PROVIDER = gql`
  query getProductList($input: GetListInputV1) {
    getProductList(input: $input) {
      status
      error
      data {
        ... on ProductListData {
          count
          productList {
            _id
            approved
            createdAt
            images {
              imageUrl
            }
            productId
            status
            title
            sku
            liveConnect {
              platform
            }
            updatedAt
            variants {
              barcode
              comparePrice
              customRule
              customLabel
              customCharge
              sku
              vendorDiscount {
                price
                type
              }
            }
            isService
            serviceId
            vendor
            vendorId
            vendorShopifyProductId
            isDraft
          }
        }
      }
    }
  }
`;
export { GET_PRODUCT_LIST, GET_PRODUCT_LIST_PROVIDER };
